// Trailing action-column width, shared by the row and the header so they align.
const companyListActionColumnWidth = () => 130;

export default companyListActionColumnWidth;
